import {
  createTemplateV1Api,
  getAllTemplatesV1Api,
  getTemplateByIdV1Api,
  updateTemplateV1Api,
  validateAccessControlTableApi,
} from '../api';
import { AccessControlState } from '../slice/initialStateGoalAccessMatrix';

export const getAllTemplatesV1 = async () => {
  try {
    const res = await getAllTemplatesV1Api();
    return (res as Array<{}>) ?? [];
  } catch (error) {
    console.error('Error fetching all templates');
  }
};

export const getTemplateByIdV1 = async (templateId: string) => {
  try {
    const res = await getTemplateByIdV1Api(templateId);
    return (res as Record<string, any>) ?? [];
  } catch (error) {
    console.error('Error fetching all templates');
  }
};

export const createTemplateV1 = async (templateData: AccessControlState) => {
  try {
    const res = await createTemplateV1Api(templateData);
    return res;
  } catch (error) {
    console.error('Error creating template', error);
    throw new Error(error);
  }
};

export const updateTemplateV1 = async (templateId: number, templateData: AccessControlState) => {
  try {
    const res = await updateTemplateV1Api(templateId, templateData);
    return res;
  } catch (error) {
    console.error('Error updating template', error);
    throw new Error(error);
  }
};

export const validateAccessControlTable = async (tableData: {
  rolesToCreateConfig?: AccessControlState['accessControl']['rolesToCreateConfig'];
  rolesToViewUpdateStatusEditDeleteConfig?: AccessControlState['accessControl']['rolesToViewUpdateStatusEditDeleteConfig'];
  rolesToUploadInsightsCustomTagConfig?: AccessControlState['accessControl']['rolesToUploadInsightsCustomTagConfig'];
}) => {
  try {
    const res = await validateAccessControlTableApi(tableData);
    return res;
  } catch (error) {
    console.error('Error validating access control table');
  }
};
